export const actionTypes: any = {
  // get
  GET_ALL_GRIEVANCE_NATURE_START: 'GET_ALL_GRIEVANCE_NATURE_START',
  GET_ALL_GRIEVANCE_NATURE_SUCCESS: 'GET_ALL_GRIEVANCE_NATURE_SUCCESS',
  GET_ALL_GRIEVANCE_NATURE_FINISH: 'GET_ALL_GRIEVANCE_NATURE_FINISH',

  // extended hours
  GET_GRIEVANCE_NATURE_START: 'GET_GRIEVANCE_NATURE_START',
  GET_GRIEVANCE_NATURE_SUCCESS: 'GET_GRIEVANCE_NATURE_SUCCESS',
  GET_GRIEVANCE_NATURE_FINISH: 'GET_GRIEVANCE_NATURE_FINISH',

  // add branch
  ADD_GRIEVANCE_NATURE_START: 'ADD_GRIEVANCE_NATURE_START',
  ADD_GRIEVANCE_NATURE_SUCCESS: 'ADD_GRIEVANCE_NATURE_SUCCESS',
  ADD_GRIEVANCE_NATURE_FINISH: 'ADD_GRIEVANCE_NATURE_FINISH',
  RESET_GRIEVANCE_NATURE: 'RESET_GRIEVANCE_NATURE',

  // update GRIEVANCE_NATURE
  UPDATE_GRIEVANCE_NATURE_START: 'UPDATE_GRIEVANCE_NATURE_START',
  UPDATE_GRIEVANCE_NATURE_SUCCESS: 'UPDATE_GRIEVANCE_NATURE_SUCCESS',
  UPDATE_GRIEVANCE_NATURE_FINISH: 'UPDATE_GRIEVANCE_NATURE_FINISH',

  // delete GRIEVANCE_NATURE
  DELETE_GRIEVANCE_NATURE_START: 'DELETE_GRIEVANCE_NATURE_START',
  DELETE_GRIEVANCE_NATURE_SUCCESS: 'DELETE_GRIEVANCE_NATURE_SUCCESS',
  DELETE_GRIEVANCE_NATURE_FINISH: 'DELETE_GRIEVANCE_NATURE_FINISH',

  // Enable GRIEVANCE_NATURE
  ENABLE_GRIEVANCE_NATURE_REQUEST: 'ENABLE_GRIEVANCE_NATURE_REQUEST',
  ENABLE_GRIEVANCE_NATURE_SUCCESS: 'ENABLE_GRIEVANCE_NATURE_SUCCESS',
  ENABLE_GRIEVANCE_NATURE_FINISH: 'ENABLE_GRIEVANCE_NATURE_FINISH',

  // Disable GRIEVANCE_NATURE
  DISABLE_GRIEVANCE_NATURE_REQUEST: 'DISABLE_GRIEVANCE_NATURE_REQUEST',
  DISABLE_GRIEVANCE_NATURE_SUCCESS: 'DISABLE_GRIEVANCE_NATURE_SUCCESS',
  DISABLE_GRIEVANCE_NATURE_FINISH: 'DISABLE_GRIEVANCE_NATURE_FINISH',

  // Enable GRIEVANCE_NATURE
  SINGLE_ENABLE_GRIEVANCE_NATURE_REQUEST: 'SINGLE_ENABLE_GRIEVANCE_NATURE_REQUEST',
  SINGLE_ENABLE_GRIEVANCE_NATURE_SUCCESS: 'SINGLE_ENABLE_GRIEVANCE_NATURE_SUCCESS',
  SINGLE_ENABLE_GRIEVANCE_NATURE_FINISH: 'SINGLE_ENABLE_GRIEVANCE_NATURE_FINISH',

  // Disable GRIEVANCE_NATURE
  SINGLE_DISABLE_GRIEVANCE_NATURE_REQUEST: 'SINGLE_DISABLE_GRIEVANCE_NATURE_REQUEST',
  SINGLE_DISABLE_GRIEVANCE_NATURE_SUCCESS: 'SINGLE_DISABLE_GRIEVANCE_NATURE_SUCCESS',
  SINGLE_DISABLE_GRIEVANCE_NATURE_FINISH: 'SINGLE_DISABLE_GRIEVANCE_NATURE_FINISH',
}

